import React, { memo } from 'react';
import { format } from 'date-fns';

/** Lightweight scroll snap slot — preserves horizontal width without mounting a full week grid. */
const EacWeekSlot = memo(function EacWeekSlot({
  panelMonday,
  weekIdx,
}: {
  panelMonday: Date;
  weekIdx: number;
}) {
  return (
    <div
      className="eac-week-slot"
      data-week-idx={weekIdx}
      aria-hidden
      title={`Week of ${format(panelMonday, 'MMM d, yyyy')}`}
    />
  );
});

export default EacWeekSlot;
